

































































import fetch from '@/utils/fetch'
import { Component, Vue, Watch, Prop, PropSync } from 'vue-property-decorator'

@Component({
  name: 'TableList'
})
export default class extends Vue {
  @Prop({ required: true }) private api!: string
  @Prop() private searchParams!: object
  @Prop() private selectedArr!: object[]
  @Prop() private keepAlive!: boolean
  @Prop() private selectable!: boolean
  @Prop() private showTotalPage!: boolean
  @Prop() private showIndex!: boolean

  private table: any = this.$refs.table

  private page: number = 1
  private size: number = 10
  private totalPage: number = 1
  private totalSize: number = 0
  private loading: boolean = false
  private isCreatedFetch: boolean = false
  private tableData: object[] = []

  created() {
    // console.log(this.selectedArr)
    this.fetchData(this.searchParams, false)
    this.isCreatedFetch = true
  }
  activated() {
    if (this.isCreatedFetch) {
      this.isCreatedFetch = false
    } else if (this.keepAlive) {
      this.update()
    }
  }

  toggleRowSelection(row: any) {
    (this.$refs.table as any).toggleRowSelection(row)
  }
  // 初始化选中
  initSelection() {
    console.log('【Components】TableList: 初始化选中状态')
    this.$nextTick(() => {
      this.tableData.map((item) => {
        (this.$refs.table as any).toggleRowSelection(item, false)
      })
      if (this.selectedArr) {
        (this.selectedArr as any).map((item: any, index: any) => {
          let row = this.tableData.find((V: any) => parseInt(V.id) === parseInt(item.id))
          if (row) {
            (this.$refs.table as any).toggleRowSelection(row, true)
          }
        })
      }
    })
  }
  // 手动X掉多选
  setUnSelection(row: any) {
    let rowData = this.tableData.find((V: any) => parseInt(V.id) === parseInt(row.id))
    if (rowData) {
      (this.$refs.table as any).toggleRowSelection(rowData, false)
    }
  }

  private fetchData(params: any, isSearch: boolean) {
    if (params) {
      if (params.page) {
        this.page = params.page
      }
      if (params.size) {
        this.size = params.size
      }
    }
    this.loading = true
    return fetch({
      url: this.api,
      method: 'post',
      data: {
        ...this.searchParams,
        ...params,
        page: this.page,
        size: this.size
      }
    }).then(res => {
      // 如果返回数据为条数为0 并且 当前页不是第一页 则向前请求一页
      if (
        (!res.data.array || res.data.array.length === 0) &&
          res.data.page > 1
      ) {
        console.log('【Components】TableList: 当前页无数据向前请求')
        this.fetchData({ ...params, page: res.data.page - 1 }, isSearch)
        return
      }

      this.page = res.data.page
      this.tableData = res.data.array || []
      this.totalPage = res.data.totalPage
      this.totalSize = res.data.totalSize
      this.$emit('update', this.tableData)
      this.loading = false
      if (this.selectable) {
        this.initSelection()
      }
    }).catch(() => {
      this.loading = false
    })
  }

  public search(params: any) {
    this.page = 1
    this.fetchData(params || null, true)
  }

  private changeSize() {
    this.page = 1
    this.fetchData(null, false)
  }

  private reload() {
    this.page = 1
    this.fetchData(null, false)
  }

  private update() {
    return this.fetchData(this.searchParams, false)
  }

  private currentChange(currentPage: number) {
    this.page = currentPage
    this.fetchData(null, false)
    this.$emit('change-page-callback', currentPage)
  }
  private handleSelectionChange(val: any) {
    // 去重
    let arr: any = []
    if (val.length > 0) {
      val.map((item: any, index: any) => {
        let Index = arr.findIndex((V: any) => item.id === V.id)
        if (Index < 0) {
          arr.push(item)
        }
      })
    }
    // console.log('selectedArr', val)

    this.$emit('section-change', val)
    this.$emit('update:selectedArr', val)
  }
  private getRowKeys(row: any) {
    return row.id
  }
  private handleMouseEnter(row: any) {
    this.$emit('mouse-enter', row)
  }

  private getSearchParams() {
    return {
      ...this.searchParams,
      page: this.page,
      size: this.size
    }
  }

  private clearSelection() {
    console.log('【Components】TableList: 清空选中项')
    ;(this.$refs.table as any).clearSelection()
    this.$emit('update:selectedArr', [])
  }

  private sortChange(column: any, prop: any, order: any) {
    this.$emit('sort-change', column, prop, order)
  }
}
